import React from 'react';

class TermsAndCondition extends React.Component<{}, {}> {

    constructor(_props: any) {
        super(_props);
    }

    public render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <h1>EasAly AI &ndash; Terms and Conditions and Privacy Policy</h1>
                <p><strong>Effective Date:</strong> October 1, 2025</p>
                <p><strong>Owned and Operated by: </strong>Tax AI, Inc. (&ldquo;Tax AI,&rdquo; &ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;)</p>
                <p>Welcome to <strong>EasAly AI</strong>, a product of Tax AI. These Terms and Conditions and Privacy Policy (collectively, &ldquo;Terms&rdquo;) govern your access to and use of EaAaly AI and related Tax AI services (collectively, the &ldquo;Services&rdquo;). By using or accessing the Services, you agree to be bound by these Terms. If you do not agree, do not use the Services.</p>
                <h1>1.&nbsp; Overview and Product Description</h1>
                <p><strong>EasAly AI</strong> is an advanced artificial intelligence platform developed by <strong>Tax AI</strong> to help individuals and businesses <strong>analyze, resolve, and manage IRS tax liabilities</strong>.</p>
                <p>It provides personalized recommendations, payment plan guidance, compliance insights, and automated support based on IRS regulations and user-provided data.</p>
                <p>Core features include:</p>
                <ul>
                    <li>Secure processing of IRS account data;</li>
                    <li>Tailored payment plan and compliance options;</li>
                    <li>Document automation and workflow management;</li>
                    <li>Predictive analytics for tax resolution</li>
                </ul>
                <p>EasAly AI is intended for informational and analytical purposes and does <strong>not </strong>constitute legal, tax, or financial advice. Users should consult a licensed tax professional when appropriate.</p>
                <h1>2.&nbsp; Acceptance of Terms</h1>
                <p>By using EasAly AI, you confirm that you:</p>
                <ul>
                    <li>Are at least 18 years old (or the age of majority in your jurisdiction);</li>
                    <li>Have read and agree to these Terms; and</li>
                    <li>Have authority to bind any organization you&nbsp;</li>
                </ul>
                <h1>3.&nbsp; Account Registration</h1>
                <p>Some Services require account creation. You agree to:</p>
                <ul>
                    <li>Provide accurate and complete registration details;</li>
                    <li>Maintain confidentiality of your login credentials; and</li>
                    <li>Notify us immediately of unauthorized use of your</li>
                </ul>
                <p>Tax AI is not responsible for losses arising from your failure to safeguard your credentials.</p>
                <h1>4.&nbsp; Information We Collect</h1>
                <p>EasAly AI collects information to provide, improve, and secure the Service.</p>
                <h1>4.1&nbsp; User-Provided Information</h1>
                <ul>
                    <li>Contact details (name, email, company name, phone number).</li>
                    <li>Financial and tax information you provide for analysis (e.g., IRS transcripts, balances owed, filing status).</li>
                    <li>Uploaded documents for verification or tax resolution</li>
                </ul>
                <h1>4.2&nbsp; Automatically Collected Information</h1>
                <ul>
                    <li>Device, browser, and operating system</li>
                    <li>IP address and geolocation (for fraud prevention).</li>
                    <li>Log data and usage analytics for performance</li>
                </ul>
                <h1>4.3&nbsp; AI Input and Output Data</h1>
                <p>We store anonymized interaction data with EasAly AI to improve model accuracy and product functionality. This data is never linked to individual identities or financial records.</p>
                <h1>5.&nbsp; How We Use Your Information</h1>
                <p>We use your data for the following purposes:</p>
                <ul>
                    <li>To provide and operate EasAly AI services;</li>
                    <li>To analyze IRS data and generate resolution options;</li>
                    <li>To perform secure ID verification (where required);</li>
                    <li>To communicate with you about your account or support requests;</li>
                    <li>To detect, prevent, and respond to security threats or fraud;</li>
                    <li>To comply with IRS, financial, and data protection</li>
                </ul>
                <p>We may also use aggregated and anonymized data for system improvement, provided it cannot identify individual users.</p>
                <h1>6.&nbsp; Data Security</h1>
                <p>Tax AI employs robust security frameworks to safeguard user data:</p>
                <ul>
                    <li><strong>Encryption:</strong> TLS/SSL encryption in transit and AES-256 encryption at</li>
                    <li><strong>Access Control:</strong> Role-based, least-privilege access for internal</li>
                    <li><strong>Network Security:</strong> Firewalls, intrusion detection, and continuous</li>
                    <li><strong>Secure Hosting: </strong>SOC 2 and ISO 27001&ndash;certified cloud</li>
                    <li><strong>Regular Audits:</strong> Independent penetration testing and security</li>
                </ul>
                <p>Despite these safeguards, no online system is entirely secure. By using EasAly AI, you acknowledge and accept inherent risks associated with internet data transmission.</p>
                <h1>7.&nbsp; Data Sharing and Disclosure</h1>
                <p>We do <strong>not sell, rent, or trade</strong> your data.</p>
                <p>We may share data only under these conditions:</p>
                <ul>
                    <li><strong>Authorized Vendors:</strong> With vetted third-party providers performing services (e.g., hosting, ID verification, analytics).</li>
                    <li><strong>Regulatory Compliance:</strong> To comply with legal requests, subpoenas, or IRS</li>
                    <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or asset sale, under confidentiality</li>
                </ul>
                <p>All vendors are required to adhere to strict data protection and security protocols equal to or stronger than our own.</p>
                <h1>8.&nbsp; Third-Party Integrations and ID Verification</h1>
                <p>EasAly AI integrates with third-party tools and systems to enhance service functionality, including:</p>
                <ul>
                    <li>IRS data retrieval and transcript processing;</li>
                    <li>Payment processors and financial verification APIs;</li>
                    <li>Secure identity verification (KYC/AML) vendors;</li>
                    <li>Document storage and e-signature</li>
                </ul>
                <h1>8.1&nbsp; ID Verification</h1>
                <p>To comply with federal standards, users may be required to verify identity using:</p>
                <ul>
                    <li>Government-issued ID;</li>
                    <li>Facial or biometric verification;</li>
                    <li>Third-party verification platforms that meet IRS and FTC</li>
                </ul>
                <p>All ID data is encrypted, used solely for verification, and deleted or anonymized according to Section 16 (Data Retention Policy).</p>
                <h1>9. Cookies and Tracking Technologies</h1>
                <p>EasAly AI uses cookies and similar technologies for:</p>
                <ul>
                    <li>Authentication and session management;</li>
                    <li>Security and fraud prevention;</li>
                    <li>Usage analytics and service</li>
                </ul>
                <p>You can control cookie preferences through your browser. Disabling cookies may limit functionality.</p>
                <h1>10.&nbsp;&nbsp; User Responsibilities</h1>
                <p>You agree to:</p>
                <ul>
                    <li>Provide accurate information;</li>
                    <li>Use EasAly AI only for lawful purposes;</li>
                    <li>Avoid unauthorized access to IRS systems or Tax AI data;</li>
                    <li>Refrain from reverse-engineering or duplicating EasAly AI</li>
                </ul>
                <h1>11.&nbsp;&nbsp; Intellectual Property</h1>
                <p>All EasAly AI software, algorithms, and documentation are owned by <strong>Tax AI, Inc.</strong></p>
                <p>You retain ownership of your personal data and uploaded content but grant Tax AI a <strong>limited license </strong>to process such data to provide and improve the Services.</p>
                <p>You may not copy, reverse-engineer, or distribute EasAly AI&rsquo;s technology or derivative works.</p>
                <h1>12.&nbsp;&nbsp; Data Retention and Deletion Policy</h1>
                <p>Tax AI retains data only as long as necessary for lawful and operational purposes.</p>
                <h1>12.1&nbsp; Retention Periods</h1>
                <ul>
                    <li><strong>User Account Data:</strong> While your account remains</li>
                    <li><strong>Tax & Financial Data:</strong> Up to <strong>seven (7) years</strong> per IRS retention</li>
                    <li><strong>ID Verification Data:</strong> Deleted within <strong>12 months </strong>post-verification unless legally required to retain.</li>
                    <li><strong>Analytics & Logs:</strong> Retained for up to <strong>24 months</strong>.</li>
                </ul>
                <h1>12.2&nbsp; Data Deletion Requests</h1>
                <p>You may request deletion of your data by emailing <a href="mailto:support@taxai.app"><strong>support@taxai.app</strong>.</a></p>
                <p>Requests will be verified and processed within <strong>30 days</strong>, except where retention is required by law, regulation, or ongoing audit obligations.</p>
                <h1>12.3&nbsp; Secure Disposal</h1>
                <p>Data is destroyed using <strong>NIST 800-88&ndash;compliant methods</strong> and securely overwritten in backup systems on the next retention cycle.</p>
                <h1>12.4&nbsp; Backup and Recovery</h1>
                <p>Encrypted backups are maintained for disaster recovery only and are governed by the same retention and deletion rules.</p>
                <h1>13.&nbsp;&nbsp; User Rights</h1>
                <p>Users may:</p>
                <ul>
                    <li>Access their personal data;</li>
                    <li>Correct inaccuracies;</li>
                    <li>Request deletion or anonymization (where permitted by law);</li>
                    <li>Withdraw consent for optional data</li>
                </ul>
                <p>To exercise these rights, contact <a href="mailto:privacy@taxai.app"><strong>privacy@taxai.app</strong>.</a> Verification of identity may be required before processing requests.</p>
                <h1>14.&nbsp;&nbsp; Disclaimer of Warranties</h1>
                <p>EasAly AI is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis.</p>
                <p>We make no warranties regarding accuracy, completeness, or uninterrupted operation. Outputs generated by EasAly AI are for informational use only and not a substitute for professional tax or legal advice.</p>
                <h1>15.&nbsp;&nbsp; Limitation of Liability</h1>
                <p>To the fullest extent permitted by law, Tax AI and its affiliates are not liable for:</p>
                <ul>
                    <li>Indirect or consequential damages;</li>
                    <li>Loss of data, revenue, or profits;</li>
                    <li>Unauthorized access to or alteration of your</li>
                </ul>
                <p>Liability in any case is limited to the amount paid by you for the Service in the preceding twelve (12) months.</p>
                <h1>16.&nbsp;&nbsp; Indemnification</h1>
                <p>You agree to indemnify and hold harmless Tax AI, its employees, and affiliates from claims, damages, or expenses arising from:</p>
                <ul>
                    <li>Your misuse of EasAly AI;</li>
                    <li>Violation of these Terms; or</li>
                    <li>Breach of tax or data protection&nbsp;</li>
                </ul>
                <h1>17.&nbsp;&nbsp; Termination</h1>
                <p>We may suspend or terminate your account for violation of these Terms, misuse, or legal compliance reasons.</p>
                <p>Upon termination, your access ceases, but data handling follows the retention and deletion policy above.</p>
                <h1>18.&nbsp;&nbsp; Compliance Statement</h1>
                <p>Tax AI maintains compliance with leading regulatory frameworks governing taxpayer and financial data protection:</p>
                <h1>18.1&nbsp; IRS Publication 1075</h1>
                <p>EasAly AI&rsquo;s encryption, access, and audit controls align with IRS Publication 1075 standards for safeguarding Federal Tax Information (FTI).</p>
                <h1>18.2&nbsp; NIST Security Framework</h1>
                <p>Tax AI adheres to <strong>NIST 800-53</strong> and <strong>NIST 800-171</strong> standards for cybersecurity, incident response, and risk management.</p>
                <h1>18.3&nbsp; FTC Safeguards Rule</h1>
                <p>We comply with the <strong>Federal Trade Commission&rsquo;s Safeguards Rule</strong> under the Gramm-Leach-Bliley Act (GLBA), protecting personally identifiable financial information.</p>
                <h1>18.4&nbsp; Data Protection and Cooperation</h1>
                <p>We fully cooperate with lawful government inquiries and adhere to all applicable U.S. federal and state privacy laws.</p>
                <h1>19. Modifications to Terms</h1>
                <p>We may update these Terms periodically. Revised versions will be posted with a new effective date. Continued use of EasAly AI constitutes acceptance of any changes.</p>
                <h1>20. Contact Information</h1>
                <p><strong>Tax AI, Inc.</strong></p>
                <p>Attn: Legal Department</p>
                <p>8000 Avalon Blvd, Ste 200, Alpharetta, GA 30009</p>
                <p>(833) 367-6691</p>
                <p>📧 <a href="mailto:support@tax-ai.us"><strong>support@tax-ai.us</strong></a></p>
            </div>
        )
    }

}

export default TermsAndCondition;